import Marquee from "react-fast-marquee";

const items = [
  "Custom Web Design",
  "Video & Motion",
  "Brand Photography",
  "Mobile-First UX",
  "Speed Optimization",
];

export const EditorialMarquee = () => (
  <section
    data-testid="editorial-marquee"
    className="relative py-10 border-y border-forest/10 bg-forest text-cream overflow-hidden"
    style={{
      backgroundImage:
        "radial-gradient(rgba(204,255,51,0.4) 1.5px, transparent 1.5px)",
      backgroundSize: "22px 22px",
    }}
  >
    <Marquee speed={38} gradient={false} autoFill>
      {items.map((t, i) => (
        <span key={i} className="flex items-center">
          <span className="font-display text-4xl md:text-6xl px-10">{t}</span>
          <span className="text-gold text-3xl">✦</span>
        </span>
      ))}
    </Marquee>
  </section>
);
